module.exports = __webpack_public_path__ + "static/media/teach-mobile.bd0b9788.jpg";